import script from "./SidebarMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&setup=true&lang=js"

import "./SidebarMenu.vue?vue&type=style&index=0&id=6881783c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6881783c"]])

export default __exports__